import { styled } from '@linaria/react';
import { fonts, layout, semantic, space } from '../../theme/tokens';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[7]};
  width: 100%;
  padding: ${space[7]} ${space[5]};
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[10]};
    max-width: ${layout.maxWidth};
    margin: 0 auto;
  }
`;

export const Greeting = styled.h1`
  margin: 0;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size['2xl']};
  line-height: 1.2;
  color: ${semantic.text.primary};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
  }
`;

export const WelcomeMessage = styled.p`
  margin: 0;
  font-family: ${fonts.heading};
  font-weight: ${fonts.weight.normal};
  font-size: ${fonts.size['2xl']};
  line-height: 1.2;
  color: ${semantic.text.secondary};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
  }
`;

export const GreetingGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;
